import HdsBtn from '@/components/HdsBtn.vue'
import HdsCard from '@/components/HdsCard.vue'
import HdsCheckbox from '@/components/HdsCheckbox.vue'
import HdsChip from '@/components/HdsChip.vue'
import HdsDialog from '@/components/HdsDialog.vue'
import HdsDropdown from '@/components/HdsDropdown.vue'
import HdsIcon from '@/components/HdsIcon.vue'
import HdsList from '@/components/HdsList.vue'
import HdsListItem from '@/components/HdsListItem.vue'
import HdsOverlay from '@/components/HdsOverlay.vue'
import HdsSelect from '@/components/HdsSelect.vue'
import HdsSnackbar from '@/components/HdsSnackbar.vue'
import HdsTextField from '@/components/HdsTextField.vue'
import HdsTooltip from '@/components/HdsTooltip.vue'

export default {
  HdsBtn,
  HdsCard,
  HdsCheckbox,
  HdsChip,
  HdsDialog,
  HdsDropdown,
  HdsIcon,
  HdsList,
  HdsListItem,
  HdsOverlay,
  HdsSelect,
  HdsSnackbar,
  HdsTextField,
  HdsTooltip,
}
